module.exports = __webpack_public_path__ + "static/media/checkbox_unchecked.fa031a0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/checkbox_unchecked.svg
// module id = 232
// module chunks = 0